import { color } from '../../../theme/Color';

export default {
  type: 'HorizontalProgressBarList',
  handler: (data) => {
    const values = data?.getPOTopVisitedPages?.data || [];

    if (!values.length) {
      return {
        hasNoData: true,
        items: [],
      };
    }

    const items = values.map((item) => ({
      title: item.pageName,
      color: color._33ABDA,
      value: item.clicksVisited,
    }));

    return {
      hasNoData: false,
      items,
    };
  },
};
